import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Camera(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M12 7.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5"
  }), React.createElement("path", {
    d: "M21.146 9.5a1 1 0 110-2 1 1 0 010 2M12 19.5c-3.859 0-7-3.141-7-7s3.141-7 7-7c3.86 0 7 3.141 7 7s-3.14 7-7 7m10-14h-4v-.551A2.45 2.45 0 0015.551 2.5H8.45A2.45 2.45 0 006 4.949V5.5H2a2 2 0 00-2 2v12a2 2 0 002 2h20a2 2 0 002-2v-12a2 2 0 00-2-2"
  }));
}

export { Camera };
//# sourceMappingURL=Camera.js.map